import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { LOCAL_CART_KEY } from './components/constants';
import addPageBuilderComponents from './services/add-page-builder-components';
import variants from './variants';
import translations from './translations';

export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addPageBuilderComponents);
  app.events.once('load:custom:page-builder:variant', async addVariant => {
    Object.keys(variants).forEach(variantKey => {
      const variant = variants[variantKey];
      addVariant(variantKey, variant);
    });
  });

  app.events.on('package:core-auth-ui:logout', () => {
    window.localStorage.removeItem(LOCAL_CART_KEY);
  });

  app.events.once('plugin:translation-fe:translations:load', loadTranslations =>
    loadTranslations(translations, PLUGIN_NAME)
  );

  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}

load.pluginName = PLUGIN_NAME;
